import { Phone, Facebook, Mail, MapPin } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/data/content";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-[#2D3728] py-16 text-white/80 md:py-20"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="font-brand text-2xl text-white">
              LAKE HOUSE JUNO
            </div>
            <p className="mt-1 text-xs font-semibold uppercase tracking-[0.4em] text-[#E8D9B5]">
              Mrągowo · Mazury
            </p>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              Całoroczny dom na wyłączność nad brzegiem jeziora Juno. Relaks,
              natura i widok na wodę — o każdej porze roku.
            </p>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold text-white">
              Nawigacja
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <button
                    data-testid={`footer-nav-${link.href.replace("#", "")}`}
                    onClick={() => scrollTo(link.href)}
                    className="text-sm text-white/60 transition-colors hover:text-[#E8D9B5]"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold text-white">
              Kontakt
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  href={CONTACT.phoneHref}
                  className="flex items-center gap-2 text-white/60 transition-colors hover:text-[#E8D9B5]"
                >
                  <Phone className="h-4 w-4" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="flex items-center gap-2 text-white/60 transition-colors hover:text-[#E8D9B5]"
                >
                  <Mail className="h-4 w-4" /> {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-white/60 transition-colors hover:text-[#E8D9B5]"
                >
                  <Facebook className="h-4 w-4" /> Facebook
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/60">
                <MapPin className="h-4 w-4" /> Jezioro Juno, Mrągowo
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 text-center text-xs text-white/40">
          © {new Date().getFullYear()} LAKE HOUSE JUNO. Wszelkie prawa
          zastrzeżone.
        </div>
      </div>
    </footer>
  );
};
